import Portal = require("portal-gis");
import Utils = require("../utils");
import Base = require("./base-command");

interface TriggerOptions {
    trace?: "true" | "false";
    delay?: string;
}

const defaults: TriggerOptions = {
    trace: "false",
    delay: "0"
}

// this command triggers one or more events, see base-command for rules
class Command extends Base<{in: TriggerOptions, out: any}> {

    static about = `
Propagates an event.

Usage Example:

    <EVENT about="When the input changes trigger a universal search event" event="change" id="change-handler" mid="app/commands/trigger">
    <OPTIONS>
        <Values about="When the input changes trigger a universal search" id="event" value="universal-search" />
    </OPTIONS>
    </EVENT>

`;

    static options = Utils.defaults({
        "trace": {
            about: "true to write data to the console",
            default: defaults.trace,
        },
        "delay": {
            about: "time to wait before triggering",
            default: defaults.delay,
        }
    }, Base.options);

    static output = {
    };

    execute(args: any = this.args) {
        let options = _.defaults(this.options, defaults);
        setTimeout(() => this.trigger(), 1000 * parseFloat(options.delay));
    }

}

export = Command; 